import { z } from 'zod';

import { TaskType } from '__generated__/GQL';
import locales from 'common/zod/locales';

export const tasksFormSchema = z.object({
  subtitle: z.string().trim().nullable(),
  title: z.string().trim().min(1, { message: locales.errors.required }),
  type: z
    .nativeEnum(TaskType)
    // We can have null values for existing older records, but we don't want to allow saving unless a value is set
    .nullable()
    .refine((type) => type !== null, {
      message: locales.errors.required,
    }),
  unitPrice: z
    .number({
      invalid_type_error: locales.errors.invalidNumber,
      required_error: locales.errors.required,
    })
    .step(0.01, {
      message: locales.formatString(locales.errors.maxDecimals, 2) as string,
    }),
  units: z
    .number({
      invalid_type_error: locales.errors.invalidNumber,
      required_error: locales.errors.required,
    })
    .step(0.001, {
      message: locales.formatString(locales.errors.maxDecimals, 3) as string,
    }),
  vatPercentage: z
    .number({
      invalid_type_error: locales.errors.invalidNumber,
      required_error: locales.errors.required,
    })
    .min(0, { message: locales.errors.positive })
    .max(100)
    .step(0.01, {
      message: locales.formatString(locales.errors.maxDecimals, 2) as string,
    }),
});

export type TasksFormSchema = z.infer<typeof tasksFormSchema>;

export const hiddenTasksFormSchema = z.object({
  invoiceCatalogItemId: z.string().nullable(),
  invoiceTaskId: z.string(),
});

export type HiddenTasksFormSchema = z.infer<typeof hiddenTasksFormSchema>;

export type FullTasksFormSchema = TasksFormSchema & HiddenTasksFormSchema;
